module.exports = __webpack_public_path__ + "img/credit-card.40702a7c.png";